// src/hooks/useTheme.js
import { useContext } from 'react';
import { ThemeContext } from '../contexts/ThemeContext.js';

/**
 * Custom hook to access theme context
 * 
 * Usage:
 *   const { theme, toggleTheme, isDark } = useTheme();
 * 
 * Returns:
 *   - theme: 'light' | 'dark'
 *   - setTheme: (theme: 'light' | 'dark') => void
 *   - toggleTheme: () => void
 *   - isDark: boolean
 */
export const useTheme = () => {
  const context = useContext(ThemeContext);
  
  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  
  return context;
};

export default useTheme;